import React from 'react';
import PropTypes from 'prop-types';
import { getISOStartOfDay } from '../../../../../../modules/datetime';
import Datepicker from '../../../../../../website/components/stateful/Datepicker';

export default class DateInput extends React.Component {
  static propTypes = {
    handleDateChange: PropTypes.func,
    input: PropTypes.shape({
      value: PropTypes.string,
      onChange: PropTypes.func,
    }).isRequired,
    meta: PropTypes.object,
    value: PropTypes.string,
    minDate: PropTypes.object,
    maxDate: PropTypes.object,
  };

  static defaultProps = {
    value: getISOStartOfDay(),
  };

  state = {
    selectedDate: this.props.input.value || this.props.value,
  };

  handleDateChange = (selectedDate) => {
    const { handleDateChange, input } = this.props;
    input.onChange(selectedDate);
    if (handleDateChange) {
      handleDateChange(selectedDate);
    }
    this.setState({
      selectedDate: selectedDate || null,
    });
  };

  componentDidUpdate(prevProps) {
    if (this.props.input.value !== prevProps.input.value) {
      this.setState({
        selectedDate: this.props.input.value || null,
      });
    }
  }

  render() {
    const { minDate, maxDate } = this.props;
    const { selectedDate } = this.state;
    return (
      <Datepicker
        selected={selectedDate ? new Date(selectedDate) : null}
        onChange={this.handleDateChange}
        placeholderText="DD/MM/YYYY"
        isClearable
        minDate={minDate}
        maxDate={maxDate}
      />
    );
  }
}
